import { render, staticRenderFns } from "./PostCardScorll.vue?vue&type=template&id=25d7e11e&scoped=true"
import script from "./PostCardScorll.vue?vue&type=script&lang=js"
export * from "./PostCardScorll.vue?vue&type=script&lang=js"
import style0 from "./PostCardScorll.vue?vue&type=style&index=0&id=25d7e11e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d7e11e",
  null
  
)

export default component.exports